import foodPackagesWebP from './food-packages.webp';
import foodPackagesPng from './food-packages.png';

export const foodPackagesSources = [foodPackagesWebP, foodPackagesPng];
